/**
 * @Description 图片处理js
 */

import { isOss } from '../components/config-v2';
import { UrlSuffix } from '../enums/qiniu';

/**
 * @description 业务方域名后缀枚举
 */
export const busiSuffixRows = ['-linhuiba', '-pms', '-location'];

/**
 * @description 七牛云业务域名
 */
export const busiDomainRows = ['linhuiba.com', 'lanhanba.net', 'lanhanba.com', 'location.pub'];


/**
 * @description 需要后缀的白名单
 */
export const domainWhiteLists = [
  'pmsimage.lanhanba.com',
  'pmsimage.location.pub',
  'data-images.location.pub',
  'middle-file.linhuiba.com',
  'images.lanhanba.com',
  'images.location.pub',
  'image.location.pub',
  'videos.linhuiba.com',
  'video.linhuiba.com',
  'cert.linhuiba.com',
  'hbanner.linhuiba.com',
  'banner.linhuiba.com',
  'img.linhuiba.com',
];

/**
 * 七牛云原始路径
 * @param url
 */
export const getQiniuOriUrl = (url: string) => {
  if (!url) return '';
  for (const index in busiSuffixRows) {
    if (url.includes(busiSuffixRows[index])) { // 获取去掉后缀的链接
      return url.split(busiSuffixRows[index])[0];
    }
  }

  return url;
};


/**
 * @description 获取图层：七牛云是带水印的原图，oss就是原图
 * @param url 链接
 * @return
 */
export const getQiniuOriginalUrl = (url: string) => {
  if (isOss && url.indexOf('linhuiba.com') === -1) return url;
  const oriUrl = getQiniuOriUrl(url);

  for (const index in busiDomainRows) {
    if (oriUrl.includes(busiDomainRows[index])) { // 判断是否是七牛云地址，如果是则加后缀，否则不加
      return refactorUrlSuffix(oriUrl, 'LocOri');
    }
  }

  return oriUrl;
};

/**
 * @description 获取七牛云带水印的大图 1000*800
 * @param url 链接
 * @return
 */
export const getQiniuLargeUrl = (url: string) => {
  const oriUrl = getQiniuOriUrl(url);

  for (const index in busiDomainRows) {
    if (oriUrl.includes(busiDomainRows[index])) { // 判断是否是七牛云地址，如果是则加后缀，否则不加
      return refactorUrlSuffix(oriUrl, 'LocLarge');
    }
  }

  return oriUrl;
};

/**
 * @description 获取七牛云带水印的中图 320*240
 * @param url 链接
 * @return
 */
export const getQiniuMiddleUrl = (url: string) => {
  const oriUrl = getQiniuOriUrl(url);

  for (const index in busiDomainRows) {
    if (oriUrl.includes(busiDomainRows[index])) { // 判断是否是七牛云地址，如果是则加后缀，否则不加
      return refactorUrlSuffix(oriUrl, 'LocMiddle');
    }
  }

  return oriUrl;
};

/**
 * @description 获取七牛云带水印的缩略图 180*180
 * @param url 链接
 * @return
 */
export const getQiniuSmallUrl = (url: string) => {
  const oriUrl = getQiniuOriUrl(url);

  for (const index in busiDomainRows) {
    if (oriUrl.includes(busiDomainRows[index])) { // 判断是否是七牛云地址，如果是则加后缀，否则不加
      return refactorUrlSuffix(oriUrl, 'LocSmall');
    }
  }

  return oriUrl;
};

/**
 * @description 渲染url 带后缀
 * @param url
 * @param type 渲染图片类型
 */
function refactorUrlSuffix(url: string, type: 'LocSmall' | 'LocMiddle' | 'LocLarge' | 'LocOri') {
  for (const index in domainWhiteLists) {
    if (url.includes(domainWhiteLists[index])) {
      return url + UrlSuffix[type];
    }
  }
  return url;
}

function refactorQiniuImageUrl(url: string, w: string|number = 320, h: string|number = 256, node = 1) {
  if (isOss) return url;
  if (typeof url === 'string') {
    if (url.indexOf('?') > -1) {
      const query = url.split('?')[1];
      if (query?.indexOf('imageView') > -1) { // 如果用户设置了，就不去管他
        return url;
      } else {
        return url + `&imageView2/${node}/w/${w}/h/${h}`;
      }
    } else {
      return url + `?imageView2/${node}/w/${w}/h/${h}`;
    }
  }
  return url;
}

/**
 * @description 获取七牛云带水印的缩略图
 * @param url 链接
 * @param w 宽度
 * @param h 高度
 * @param node 图片截图类型 [https://developer.qiniu.com/dora/api/basic-processing-images-imageview2]
 * mode=0，使用姿势：/0/w/<LongEdge>/h/<ShortEdge>
1、限定缩略图的长边最多为<LongEdge>，短边最多为<ShortEdge>，进行等比缩放，不裁剪。
2、如果只指定 w 参数则表示限定长边（短边自适应），只指定 h 参数则表示限定短边（长边自适应）。

mode=1，使用姿势：/1/w/<LongEdge>/h/<ShortEdge>
1、限定缩略图的宽最少为<LongEdge>，高最少为<ShortEdge>，进行等比缩放，居中裁剪。
2、转后的缩略图通常恰好是 <LongEdge>x<ShortEdge> 的大小（有一个边缩放的时候会因为超出矩形框而被裁剪掉多余部分）。
3、如果只指定 w 参数或只指定 h 参数，代表限定为长宽相等的正方图。

mode=2，使用姿势：/2/w/<LongEdge>/h/<ShortEdge>
1、限定缩略图的长边最少为<LongEdge>，短边最少为<ShortEdge>，进行等比缩放，不裁剪。
2、如果只指定 w 参数则表示限定宽（高自适应），只指定 h 参数则表示限定高（宽自适应）。
3、它和模式0类似，区别只是限定宽和高，不是限定长边和短边。从应用场景来说，模式0适合移动设备上做缩略图，模式2适合PC上做缩略图。

mode=3，使用姿势：/3/w/<LongEdge>/h/<ShortEdge>
1、限定缩略图的长边最少为<LongEdge>，短边最少为<ShortEdge>，进行等比缩放，不裁剪。
2、如果只指定 w 参数或只指定 h 参数，代表长宽限定为同样的值。你可以理解为模式1是模式3的结果再做居中裁剪得到的。

mode=4，使用姿势：/4/w/<LongEdge>/h/<ShortEdge>
1、限定缩略图的长边最少为<LongEdge>，短边最少为<ShortEdge>，进行等比缩放，不裁剪。
2、如果只指定 w 参数或只指定 h 参数，表示长边短边限定为同样的值。这个模式很适合在手持设备做图片的全屏查看（把这里的长边短边分别设为手机屏幕的分辨率即可），生成的图片尺寸刚好充满整个屏幕（某一个边可能会超出屏幕）。

mode=5，使用姿势：/5/w/<LongEdge>/h/<ShortEdge>
1、限定缩略图的长边最少为<LongEdge>，短边最少为<ShortEdge>，进行等比缩放，居中裁剪。
2、如果只指定 w 参数或只指定 h 参数，表示长边短边限定为同样的值。同上模式4，但超出限定的矩形部分会被裁剪。
 * @return
 * @demo
 */
export const getQiniuThumbnailImagelUrl = (url: string, w: string|number = 320, h: string|number = 256, node: 0 | 1 | 2 | 3 | 4 | 5 = 1) => {
  const oriUrl = getQiniuOriginalUrl(url);
  return refactorQiniuImageUrl(oriUrl, w, h, node);
};
